import React, { useState, useRef } from "react";

import { ImageRow, ImageContainer, NavIcon } from "./MediaSectionStyles";
import ZoomArea from "./ZoomArea";
import Media from "./Media";

const threshold = 30; //required min distance traveled to be considered swipe

const MediaSection = ({
  dataList,
  activeItem,
  setActiveItem,
  data,
  rotate,
  sliderValue,
}) => {
  const [touchData, setTouchData] = useState(null);

  const containerRef = useRef();

  const source = data?.src ?? (dataList && dataList[activeItem]?.src);
  const contentType =
    data?.contentType ?? (dataList && dataList[activeItem]?.contentType);

  const handleTouchStart = (e) => {
    const touchobj = e.changedTouches[0];
    setTouchData({ startX: touchobj.pageX, startTime: new Date().getTime() });
  };

  const handleTouchEnd = (e) => {
    const touchobj = e.changedTouches[0];

    const swipeDistance = touchobj.pageX - touchData.startX;

    if (swipeDistance > threshold && swipeDistance > 0 && sliderValue === 0) {
      if (activeItem > 0 && dataList) {
        setActiveItem(activeItem - 1);
      }
    } else if (
      Math.sign(swipeDistance) * swipeDistance > threshold &&
      swipeDistance < 0 &&
      sliderValue === 0
    ) {
      if (dataList && activeItem < dataList.length - 1)
        setActiveItem(activeItem + 1);
    }
  };

  const renderNextIcon = () => {
    if (!dataList || parseInt(sliderValue, 10) > 0) {
      return null;
    }
    return (
      <NavIcon iconName="next" onClick={() => setActiveItem(activeItem + 1)} />
    );
  };

  const renderPrevIcon = () => {
    if (!dataList || parseInt(sliderValue, 10) > 0) {
      return null;
    }
    return (
      <NavIcon iconName="prev" onClick={() => setActiveItem(activeItem - 1)} />
    );
  };

  const renderMedia = () => {
    if (parseInt(sliderValue, 10) === 0) {
      return (
        <Media source={source} contentType={contentType} rotate={rotate} />
      );
    }

    return null;
  };

  if (!source) {
    return null;
  }

  return (
    <ImageRow>
      {renderPrevIcon()}
      <ImageContainer
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        ref={containerRef}
        tabIndex="1"
      >
        {renderMedia()}
        {sliderValue > 0 && (
          <ZoomArea
            canvasWidth={containerRef.current?.offsetWidth || 0}
            canvasHeight={containerRef.current?.offsetHeight || 0}
            rotate={rotate}
            sliderValue={sliderValue}
            src={source}
          />
        )}
      </ImageContainer>
      {renderNextIcon()}
    </ImageRow>
  );
};

export default MediaSection;
